import { Action, OperationType } from "puzzle";

export const updateDownloadSourceFilesButtons: Action = [{
  data: {
    labelTextSelected: 'downloadSource.downloadSelected',
    buttonActionNameSelected: 'downloadSelectedFilesButtonAction',
    labelTextAll: 'downloadSource.downloadAll',
    buttonActionNameAll: 'downloadAllButtonAction',
    primary: true
  },
  customTags: [{
    name: 'downloadSelected',
    args: ['labelTextSelected', 'selectedFiles', 'buttonActionNameSelected', 'primary'],
    disabled: '!{selectedFiles}'
  }, {
    name: 'downloadAll',
    args: ['labelTextAll', 'total', 'buttonActionNameAll', 'primary'],
  }],
  type: OperationType.updateDialog
}];

export const downloadAllButtonAction: Action = [{
  moduleName: 'SourceFilesDialog',
  name: 'getParamsDownloadAll',
  mappingName: 'params',
  type: OperationType.addOperationData
}, {
  name: 'download_submission_source_files',
  args: ['params'],
  type: OperationType.action
}]

export const downloadSelectedFilesButtonAction: Action = [{
  moduleName: 'SourceFilesDialog',
  name: 'getParamsDownloadSelectedFiles',
  mappingName: 'params',
  type: OperationType.addOperationData
}, {
  name: 'download_submission_source_files',
  args: ['params'],
  type: OperationType.action
}]
